import React from 'react';
import {
  CompanyAddress,
  CompanyPhoneNumber,
  ContactEmailAddress,
} from '../../utils/Constants';
// Images
import CheersOutline from '../../assets/images/outlines/cheers-with-pints-outline-sketch-white.png';

const MapComponent = () => {
  return (
    <section
      id='map'
      className='grid w-full bg-colour1 text-white border-b-2 border-t-2 border-solid border-colour2 h-full'
    >
      <div className='grid w-full min-h-screen py-10 px-6 lg:container lg:mx-auto'>
        <section className='grid lg:grid-cols-2 gap-10 mx-auto lg:my-auto'>
          {/* Info Section */}
          <section className='grid gap-4'>
            <div className='text-center grid h-fit gap-2 py-4'>
              <h5 className='text-4xl md:text-5xl font-GaramondBold font-bold'>
                Visit The Tavistock Inn
              </h5>
              <p className='text-lg md:text-xl'>{CompanyAddress}</p>

              <div>
                <img
                  src={CheersOutline}
                  alt='Cheering glasses pub outline'
                  className='w-fit max-w-56 lg:max-w-80 mx-auto mt-2'
                  loading='lazy'
                />
              </div>
            </div>

            {/* Additional Content */}
            <div className='text-center grid gap-2'>
              <h3 className='text-2xl font-semibold text-text-colour'>
                Opening Hours
              </h3>
              <p className='text-lg'>Monday - Saturday: 12:00 PM - 11:00 PM</p>
              <p className='text-lg'>Sunday: 12:00 PM - 10:00 PM</p>

              <h3 className='text-2xl font-semibold mt-4 text-text-colour'>
                Contact Us
              </h3>
              <p className='text-lg'>Phone: {CompanyPhoneNumber}</p>
              <p className='text-lg'>Email: {ContactEmailAddress}</p>
            </div>

            {/* Call-to-Action */}
            {/* <div className='text-center mt-4'>
            <a
            href='/reservations'
            className='bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded'
            >
            Make a Reservation
            </a>
            </div> */}
          </section>

          <div className='grid items-center lg:pl-10 w-full py-6'>
            <div className='relative w-full' style={{ aspectRatio: '16 / 9' }}>
              <iframe
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2535.056924695417!2d-4.1449278884489065!3d50.551711379949964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486cf4c2f99d4cf5%3A0x374219e65399b35!2s19%20Brook%20St%2C%20Tavistock%20PL19%200HD!5e0!3m2!1sen!2suk!4v1731440245893!5m2!1sen!2suk'
                allowFullScreen=''
                loading='lazy'
                title='The Tavistock Inn'
                referrerPolicy='no-referrer-when-downgrade'
                className='w-full h-full lg:min-h-[400px]'
              ></iframe>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default MapComponent;
